import React, {useEffect, useState} from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import { RepairItem } from './RepairItem'
import { AuditLogs } from './AuditLogs'
import { Link } from '@reach/router'
import {useDispatch} from "react-redux";
import * as rest from "../../services";
import {showErrorToast} from "../../state/toasts";
import {DataGrid, GenericSearchForm, Loading, MomentFormatter} from "../../components";
import {TableState} from "../../components/DataGrid/types";
import {GetApiResponse} from "../../services/types";
import {REPAIR_TYPES} from "../../GSXComponents";
import {repairStatus} from "../Tickets/PartRequests/constants";

export const RepairDetailsFormatter = function (cell:string, _row:any) {
  return (
    <components.Slider
      title={cell}
      header={`GSX Repair ${cell}`}
      variant="light"
    >
      <RepairItem repairID={cell}/>
    </components.Slider>
  )
}

export const RepairActionFormatter = function (cell:string, row:any) {
  return (
    <components.Slider
      title="History"
      header={`GSX Audit History For Repair ${cell}`}
      variant="light"
    >
      <AuditLogs repairID={row.repairId}/>
    </components.Slider>
  )
}

export const PurchaseOrderFormatter = function (cell:string, _row:any) {
  return (
    <Link className={'text-dark'} to={`/dashboard/ticket/${cell}`}>
      {cell}
    </Link>
  )
}


export const RepairsDataGrid = () => {
  const dispatch = useDispatch()
  const [response, setResponse] = useState<GetApiResponse>()
  const [loading, setLoading] = useState<boolean>(false)
  const [gridData, setGridData] = useState({ page: 1, page_size: 10 })
  const [filters, setFilters] = useState({repairType:"CIN"})
  const handleTableChange = (_type:string, { page, sizePerPage }:TableState) => {
    const paginationFilters = {
      "page": page,
      "page_size": sizePerPage,
    }
    setGridData(paginationFilters)
  }
  const handleFilter = (data:any) => {
    if(!data){
      data = {repairType:"CIN"}
    }
    if(data.repairIds){
      data.repairIds = data.repairIds.split(",")
    }
    const searchFilters = { ...data}
    setFilters(searchFilters)
    setGridData({ "page": 1, "page_size": 10 })
  }

  const getData = () => {
     let finalPayload = {
        ...{
          search_criteria: filters,
        },
        ...gridData,
      };

      setLoading(true)
      new rest.GSXService()
        .repair_summary(finalPayload)
        .then((res) => {
          setResponse(res)
          setLoading(false)
        })
        .catch((_errors) => {
          setLoading(false)
          dispatch(
            showErrorToast(
              'Error.',
              "Could not load repair summary."
            )
          )
        })
    }

    useEffect(() => {
    getData()
  }, [gridData,filters])

  const columns = [
    {
      dataField: 'repairId',
      text: 'Repair Id',
      type: 'string',
      formatter: RepairDetailsFormatter,
      searchFieldType: "text",
      searchFieldKey:"repairIds"

    },
    {
      dataField: 'repairType',
      text: 'Repair Type',
      type: 'string',
      searchFieldType: 'select',
      options: REPAIR_TYPES.map(x=>x.code),

    },
    {
      dataField: 'repairStatus',
      text: 'Repair Status',
      type: 'string',
      searchFieldType: 'select',
      options: repairStatus,
      searchFieldKey:"repairStatusCode"

    },
    {
      dataField: 'repairStatusDescription',
      text: 'Status Description',
      type: 'string',
    },
    {
      dataField: 'repairCreateDate',
      text: 'Creation Date',
      type: 'string',
      formatter: MomentFormatter,

    },
    {
      dataField: 'purchaseOrderNumber',
      text: 'Purchase Order Number',
      type: 'string',
      formatter: PurchaseOrderFormatter,
       searchFieldType: "text"
    },
    {
        dataField: 'repairId',
      type: 'string',
      formatter: RepairActionFormatter,
    },
  ]

  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>
            GSX Repairs
          </ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs={6}>
            <components.Slider
              size="lg"
              title={components.ICONS.SEARCH}
             sliderWidth={"20vw"}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-1"> GSX Repairs</span>
                </span>
              }
            >
              <GenericSearchForm
                onFilter={handleFilter}
                columns={columns}
              />
            </components.Slider>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        {loading && <Loading/>}
        {response && response.results && <DataGrid
          data={response.results}
          sizePerPage={response.page_size}
          page={response.current}
          columns={columns}
          count={response.count}
          onTableChange={handleTableChange}
        />}
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
